/* eslint-disable fp/no-mutation */
import L from 'lodash'

export const setCookie = function(
  name: string,
  value: string | number | boolean,
): void {
  document.cookie = `${name}=${value}`
}

export const getCookie = function(name: string): string | null {
  const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`))

  return L.isNil(match) ? null : match[2]
}

export const deleteCookie = function(name: string): void {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:01 GMT;`
}
